import React, { useEffect, useMemo } from 'react';
import { useIntl } from 'react-intl';
import { Button } from '@99designs/frontend-components/components/Button';
import Heading from '../../../../shared/components/Heading';
import Paragraph from '../../../../shared/components/Paragraph';
import { webOnboarderGetStartedPath } from '../../../../shared/lib/platformUrls';
import Box from '../../../../shared/spa/core-components/Box';
import { getAvailableWebBuilders } from '../../WebBuilderSelector/webBuilders';
import ComparisonTable from './ComparisonTable';

function ComparisonTableSection() {
    const { locale } = useIntl();
    const webBuilders = getAvailableWebBuilders(locale);

    return (
        <>
            <div className="row">
                <div className="column">
                    <Heading type="h2" variations={['h2', 'with-divider']}>
                        {__('Let’s compare')}
                    </Heading>
                    <Box paddingLeft={['none', 'gutter']}>
                        <Paragraph variations={['narrow-widescreen']}>
                            {__(
                                'Different web builders cater to different industries and budgets. Our nifty comparison chart should help you make the right choice.'
                            )}
                        </Paragraph>
                    </Box>
                </div>
            </div>
            <ComparisonTable webBuilders={webBuilders} />
            <Box display="flex" justifyContent="center" marginTop="gutter">
                <Button variations={['jumbo', 'primary']} href={webOnboarderGetStartedPath()}>
                    {__('Get started')}
                </Button>
            </Box>
        </>
    );
}

export default ComparisonTableSection;
